/* eslint-disable import/prefer-default-export */
export const layouts = [
  {
    name: 'default',
    tileCount: 6,
    defaultMarketIds: ['Los Angeles', 'New York City'],
    marketCount: 2,
    orientation: 'portrait',
    resolution: '1080p',
  },
  {
    name: 'landscape-4k-4m',
    tileCount: 8,
    defaultMarketIds: ['New York City', 'Beijing', 'Los Angeles', 'Paris'],
    marketCount: 4,
    orientation: 'landscape',
    resolution: '4k',
  },
  {
    name: 'landscape-4k',
    tileCount: 4,
    defaultMarketIds: ['New York City', 'Beijing', 'Los Angeles', 'Paris', 'Geneva', 'Las Vegas', 'Melbourne', 'Amsterdam'],
    marketCount: 8,
    orientation: 'landscape',
    resolution: '4k',
  },
];

export function getLayoutConfig(layout) {
  return layouts.find(item => item.name === layout) || layouts[0];
}
